import React, { useState, useEffect } from 'react'
import $ from 'jquery'
import { getData, putData } from '../../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import Header from '../../../components/generals/header'
import Loading from '../../../components/generals/loading'
import styles from '../../../css/generals/Checkbox.module.css'
import stylesPreferences from '../../../css/preferences/Preferences.module.css'
import stylesIndex from '../../../css/Index.module.css'
import { compareObj } from '../../../components/generals/toolsFunctions'
import store from '../../../reducer/store'
import { popupSimple } from '../../../components/generals/popups'
import { MultiSelect } from 'primereact/multiselect'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function Configs () {
  // const data = useSelector((state) => state.preferences.configs);
  const [settingsToCompare, setsettingsToCompare] = useState({})
  const [configs, setConfigs] = useState({})
  const [useGoogle, setUseGoogle] = useState()
  const [selectedSoUseGoogle, setSelectedSoUseGoogle] = useState([])
  const { user } = store.getState()
  const role = user.roles
  const { t } = useTranslation('connectionPreferences')
  const navigate = useNavigate()

  const soDevices = [
    { name: 'Windows', code: 'Windows' },
    { name: 'Android', code: 'Android' },
    { name: 'Chrome OS', code: 'Chrome OS' },
    { name: 'IOS', code: 'IOS' },
    { name: 'Ubuntu', code: 'Ubuntu' },
    { name: 'Debian', code: 'Debian' }
  ]

  useEffect(() => {
    const getPreferences = async () => {
      const { data } = await getData('preferences', 1, navigate)
      // console.log(data)
      if (data) {
        setConfigs(data)
        setsettingsToCompare(data)
        viewCheckbox(data.use_other)
        setUseGoogle(data.use_google.length > 0)
        if (data.use_google.length > 0) {
          const selectedSo = soDevices.filter(so => data.use_google.includes(so.name))
          setSelectedSoUseGoogle(selectedSo)
        }
      }
    }

    getPreferences()
  }, [])

  function viewCheckbox (others) {
    if (others === true) {
      $('#others_use').prop('checked', true)
    } else {
      $('#others_use').prop('checked', false)
    }
  }

  const handleInputChange = (e) => {
    if (e.target.name === 'use_other') {
      setConfigs({
        ...configs,
        [e.target.name]: $('#others_use').is(':checked')
      })
    } else if (e.target.name === 'applications' || e.target.name === 'stats') {
      setConfigs({
        ...configs,
        [e.target.name]: $(`#${e.target.name}`).is(':checked')
      })
    } else if (e.target.name === 'use_google') {
      setUseGoogle($(`#${e.target.name}`).is(':checked'))
      setConfigs({
        ...configs,
        use_google: [],
        time_location_google: null,
        key_google: '',
        url_google: ''
      })
      setSelectedSoUseGoogle([])
    } else {
      setConfigs({
        ...configs,
        [e.target.name]: e.target.type === 'number' ? e.target.value === '' ? null : parseInt(e.target.value) : e.target.value
      })
    }
  }

  const handleKeyDown = (e) => {
    // evitar escribir "-"
    if (e.key === '-') {
      e.preventDefault()
    }
  }

  const sendConfigs = async () => {
    const date = new Date().toISOString()

    const comparation = compareObj(configs, settingsToCompare)

    if (useGoogle && (configs.url_google === null || configs.url_google === '')) {
      popupSimple('info', t('message1'))
    } else if (useGoogle && (configs.key_google === null || configs.key_google === '')) {
      popupSimple('info', t('message2'))
    } else if (useGoogle && (configs.time_location_google === null || configs.time_location_google === '')) {
      popupSimple('info', t('message6'))
    } else if (useGoogle && configs.url_google && configs.key_google && configs.time_location_google && (selectedSoUseGoogle?.length === 0)) {
      popupSimple('info', t('message7'))
    } else if (comparation) {
      popupSimple('info', t('message3'))
    } else {
      setConfigs({
        ...configs,
        date
      })

      const { data } = await putData('preferences', configs, navigate)
      if (data.result === true) {
        popupSimple('success', t('message4'))
      } else {
        popupSimple('error', t('message5'))
      }
    }
    setsettingsToCompare(configs)
  }

  if (Object.keys(configs).length === 0) {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Loading color="primary"/>
        </div>
      </div>)
  } else {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Header title={t('title')} margin="0" />
          {role?.preferencesSettingsPage.times &&
          <>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label1')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_connection} name="time_connection" onChange={handleInputChange} onKeyDown={handleKeyDown} type="number" min={5} max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label2')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_persistence} name="time_persistence" type="number" onChange={handleInputChange} onKeyDown={handleKeyDown} min={5}
            max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label3')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small2')})</small>
                <input value={configs.time_off_line_disconnection} name="time_off_line_disconnection" type="number" onChange={handleInputChange} onKeyDown={handleKeyDown} min={1}
             className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
          </>}
          {role?.preferencesSettingsPage.locations &&
          <>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label4')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input value={configs.use_other} checked={configs.use_other} id="others_use" name="use_other" type="checkbox" onChange={handleInputChange} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div>
            <div id="div_google" className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label5')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input checked={useGoogle} id="use_google" name="use_google" type="checkbox" onChange={handleInputChange} className="focus"/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div>
            <div id="div_so_use_google" className={`${styles.componentBox} ${stylesPreferences.boxSoUseGoogle}`} style={{ display: useGoogle === true ? 'block' : 'none' }}>
              <div className={`${styles.containerDiv} ${stylesPreferences.alignSoUseGoogle}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref} ${stylesPreferences.labelSoUseGoogle}`}>{t('label6')}</label>
                <MultiSelect value={selectedSoUseGoogle} onChange={(e) => {
                  setSelectedSoUseGoogle(e.value)
                  setConfigs({
                    ...configs,
                    use_google: e.value?.map(so => so.name)
                  })
                }} options={soDevices} optionLabel="name" display="chip"
                placeholder={t('placeholder1')} maxSelectedLabels={4} className={stylesPreferences.multiSelectSoUseGoogle} />
              </div>
            </div>
            <div id="div_url" className={`${styles.componentBox} ${stylesPreferences.boxInputLargePref}`} style={{ display: useGoogle === true ? 'block' : 'none' }}>
              <div className={`${styles.containerDiv} ${stylesPreferences.alignInputLarge}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label7')}</label>
                <input value={configs.url_google} name="url_google" onChange={handleInputChange} type="text" className={`${styles.focus} ${stylesPreferences.inputLarge}`}/>
              </div>
            </div>
            <div id="div_key" className={`${styles.componentBox} ${stylesPreferences.boxInputLargePref}`} style={{ display: useGoogle === true ? 'block' : 'none' }}>
              <div className={`${styles.containerDiv} ${stylesPreferences.alignInputLarge}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label8')}</label>
                <input value={configs.key_google} name="key_google" onChange={handleInputChange} type="text" className={`${styles.focus} ${stylesPreferences.inputLarge}`}/>
              </div>
            </div>
            <div className={styles.componentBox} style={{ display: useGoogle === true ? 'block' : 'none' }}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label9')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_location_google} onChange={handleInputChange} onKeyDown={handleKeyDown} name="time_location_google" type="number" min={1} max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label10')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_location} onChange={handleInputChange} onKeyDown={handleKeyDown} name="time_location" type="number" min={1} max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
          </>}
          {role?.preferencesSettingsPage.reports &&
          <>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label11')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input value={configs.applications} checked={configs.applications} id="applications" name="applications" type="checkbox" onChange={handleInputChange} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label12')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input value={configs.stats} checked={configs.stats} id="stats" name="stats" type="checkbox" onChange={handleInputChange} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div>
          </>}
          <div className={`end-footer-body ${stylesPreferences.btnEnd}`}>
            <Button onClick={sendConfigs} variant="dark">
            <i className="fas fa-save" style={{ marginRight: '0.5rem' }}></i>
            {t('button1')}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
